var _path, _g, _path2, _rect, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetPaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 406,
    viewBox: "0 0 323 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5112_1660",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 347,
    width: 300,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.6 347H11V405.275H310.6V347Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5112_1660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.667 400.605C231.835 400.605 289.529 342.893 289.529 271.701C289.529 200.508 231.835 142.796 160.667 142.796C89.4985 142.796 31.8052 200.508 31.8052 271.701C31.8052 342.893 89.4985 400.605 160.667 400.605Z",
    fill: "#FFC289"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 274H310.601",
    stroke: "#343239",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 320.263,
    height: 198.754,
    rx: 9,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.371 85.9473C214.102 85.0407 213.472 84.2814 212.641 83.8331C211.81 83.3849 210.833 83.285 209.923 83.5557C209.013 83.8253 208.249 84.4431 207.788 85.2744C207.339 86.1056 207.238 87.0829 207.497 87.9928C210.653 98.5553 209.968 109.893 205.553 119.997C201.15 130.101 193.309 138.321 183.424 143.198C173.539 148.076 162.25 149.297 151.545 146.644C140.851 143.992 131.438 137.638 124.967 128.708C118.508 119.779 115.419 108.849 116.239 97.8577C117.059 86.865 121.744 76.5193 129.472 68.6527C137.189 60.785 147.445 55.9053 158.419 54.8775C169.394 53.8497 180.38 56.7399 189.434 63.035C190.209 63.5798 191.175 63.7921 192.118 63.6247C193.051 63.4573 193.882 62.9249 194.433 62.1442C194.972 61.3624 195.185 60.3974 195.017 59.4606C194.848 58.5237 194.32 57.6913 193.534 57.1465C183.121 49.9113 170.484 46.5942 157.858 47.7837C145.232 48.9722 133.437 54.591 124.552 63.6438C115.666 72.6966 110.275 84.6003 109.331 97.2466C108.388 109.893 111.948 122.467 119.373 132.741C126.81 143.016 137.638 150.329 149.95 153.385C162.261 156.441 175.246 155.043 186.625 149.439C198.005 143.836 207.025 134.387 212.113 122.766C217.191 111.145 217.988 98.1026 214.371 85.9473Z",
    fill: "#343239"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.965 98.8665C139.275 98.2036 138.37 97.8379 137.42 97.8459C136.471 97.8538 135.566 98.2366 134.899 98.9109C134.232 99.5864 133.847 100.499 133.836 101.452C133.836 102.407 134.198 103.326 134.854 104.011L152.912 122.205C153.59 122.886 154.506 123.27 155.467 123.27C156.428 123.27 157.344 122.886 158.022 122.205L206.78 73.0848C207.447 72.3979 207.809 71.4787 207.798 70.5254C207.786 69.5709 207.413 68.6585 206.746 67.9842C206.068 67.3088 205.163 66.9261 204.213 66.9181C203.275 66.9101 202.359 67.2769 201.68 67.9398L155.467 114.487L139.965 98.8665Z",
    fill: "#343239"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPaid);
export default __webpack_public_path__ + "static/media/getPaid.5db70246fc5f40da207c2aaabaaa1d73.svg";
export { ForwardRef as ReactComponent };